import React from 'react'
import { withTheme } from 'styled-components';

import ic_exc_orange from 'App/assets/images/ic_exc_orange.png'
import { ButtonReg } from 'atoms/Buttons'
import Icon from 'atoms/Icon';
import IconPng from 'atoms/IconPng';
import { FormTxtArea } from 'atoms/Inputs'
import { Label } from 'atoms/Texts'
import {
  MainWrapper,
  Close,
  Head,
  LevelRowContainer,
  ModalFooter,
} from './styles'

const ReopenTaskModal = ({
  theme,
  data,
  fnSwitch,
  fnChange,
  fnSubmit,
  isDisabled,
}) => (
  <MainWrapper>
    <Close>
      <Icon
        size="lg"
        color={theme.mocaPurple}
        onClick={fnSwitch}
        showPointer
      />
    </Close>
    <Head>
      <IconPng srcIcon={ic_exc_orange} size={'auto'} h={'120'} mb={'24px'} />
      <Label lineheight={'29px'} size={'20px'} mb={'10px'}>
        Re-open Issue
      </Label>
      <Label lineheight={'29px'} size={'14px'} mb={'0px'} color={theme.mocaLtGrey} style={{ textAlign: 'center' }}>
        Are you sure want re-open this issue?
      </Label>
    </Head>
    <LevelRowContainer>
      <div className="col-12">
        <Label lineheight={'14px'} size={'12px'}>
          Reason*
        </Label>
        <FormTxtArea
          placeholder={'Enter reason'}
          mb={'16px'}
          width="100%"
          value={data.reason}
          onChangeVal={e => fnChange(e.target.value, 'reason')}
        />
      </div>
    </LevelRowContainer>
    <ModalFooter>
      <ButtonReg
        onClick={fnSubmit}
        disabled={isDisabled}
        btnTxt="Yes"
        transparent
      />
      <ButtonReg
        onClick={fnSwitch}
        btnTxt="No"
      />
    </ModalFooter>
  </MainWrapper>
)

export default withTheme(ReopenTaskModal)
